import { ComponentStyleConfig } from '@chakra-ui/react';

export const QrChekin: ComponentStyleConfig = {
  parts: ['container', 'qrImage', 'qrWrapper', 'actions'],
  baseStyle: ({ popupSize }) => ({
    container: {
      display: 'inline-flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      width: popupSize.width,
      minHeight: popupSize.height,
      height: 'auto',
      padding: 2,
      backgroundColor: 'surface2',
      borderRadius: 4,
      border: '1px solid',
      borderColor: 'borderBase',
    },
    qrImage: {
      width: '100%',
      objectFit: 'cover',
      WebkitUserDrag: 'none',
    },
    qrWrapper: {
      maxWidth: 208,
      maxHeight: 208,
      width: '100%',
      height: '100%',
      padding: '12px',
      borderRadius: 4,
      backgroundColor: 'white',
    },
    actions: {
      width: '100%',
      display: 'inline-flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      pb: 4,
    },
  }),
  variants: {},
  sizes: {},
  defaultProps: {},
};
